import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import React, {useCallback, useEffect, useState} from "react";
import UnitList from "../../molecules/unit-list/unit-list.component.js";
import {MergeUnitsListOrigin} from "./merge-units-list.types.js";
import AlertDialog from "../../molecules/alert-dialog/alert-dialog.component.js";
import MaterialBox from "../../../../__snowpack__/pkg/@mui/material/Box.js";
import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import Button from "../../atoms/button/button.component.js";
function MergeUnitsList({
  dataSrc,
  dataDst,
  onChange,
  onSearchDst,
  onSearchSrc,
  mergeQueue
}) {
  const {
    t
  } = useTranslation();
  const checkQueue = useCallback((id) => !!mergeQueue.find(([queueSrc, queueDst]) => [queueSrc?.id, queueDst?.id].includes(id)), [mergeQueue]);
  const parseUnitsToList = useCallback((data) => data.map(({
    id,
    possible_sync_missing: disabled,
    building,
    number,
    sq_feet
  }) => ({
    id,
    disabled: disabled || checkQueue(id),
    leftText: [number, building].filter(Boolean).join("-"),
    rightText: sq_feet ? [sq_feet, t("units.areaAbbreviated")].join(" ") : ""
  })), [t, checkQueue]);
  const [listSrc, setListSrc] = useState(() => parseUnitsToList(dataSrc));
  const [listDst, setListDst] = useState(() => parseUnitsToList(dataDst));
  const [dialogAddQueueOpen, setDialogAddQueueOpen] = useState(false);
  const [, setSelected] = useState([void 0, void 0]);
  const [pair, setPair] = useState([void 0, void 0]);
  const [reset, setReset] = useState(false);
  useEffect(() => {
    if (dataSrc) {
      setListSrc(() => parseUnitsToList(dataSrc));
    }
    if (dataDst) {
      setListDst(() => parseUnitsToList(dataDst));
    }
  }, [dataDst, dataSrc, parseUnitsToList]);
  const updateList = useCallback((list, id) => {
    const index = list.findIndex((item) => item.id === id);
    const newList = [...list];
    newList[+index] = {
      ...newList[+index],
      possible_sync_missing: true
    };
    return newList;
  }, []);
  const handleChange = useCallback((origin, value) => {
    setSelected((selected) => {
      setReset(false);
      let [src, dst] = selected;
      if (origin === MergeUnitsListOrigin.SRC) {
        src = dataSrc.find((l) => l.id === value.id);
        const dataDstTemp = updateList(dataDst, value.id);
        setListDst(parseUnitsToList(dataDstTemp));
      } else if (origin === MergeUnitsListOrigin.DST) {
        dst = dataDst.find((l) => l.id === value.id);
        const dataSrcTemp = updateList(dataSrc, value.id);
        setListSrc(parseUnitsToList(dataSrcTemp));
      }
      if (src && dst) {
        setPair([src, dst]);
        setDialogAddQueueOpen(true);
        return [void 0, void 0];
      }
      return [src, dst];
    });
  }, [dataDst, dataSrc, parseUnitsToList, updateList]);
  const handleAddQueueAccept = useCallback(() => {
    onChange(pair);
    setReset(true);
    setDialogAddQueueOpen(false);
  }, [pair]);
  const handleAddQueueCancel = useCallback(() => {
    setDialogAddQueueOpen(false);
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(UnitList, {
    title: "units.mergeUnitSrc",
    data: listSrc,
    onChange: (value) => handleChange(MergeUnitsListOrigin.SRC, value),
    onSearch: onSearchSrc,
    reset
  }), /* @__PURE__ */ React.createElement(UnitList, {
    title: "units.mergeUnitDst",
    data: listDst,
    onChange: (value) => handleChange(MergeUnitsListOrigin.DST, value),
    onSearch: onSearchDst,
    reset
  }), dialogAddQueueOpen && /* @__PURE__ */ React.createElement(AlertDialog, {
    open: dialogAddQueueOpen,
    onClose: handleAddQueueCancel,
    title: t("units.addQueueDialogTitle"),
    showCloseIcon: true,
    content: /* @__PURE__ */ React.createElement(MaterialBox, {
      height: 300
    }, /* @__PURE__ */ React.createElement(MaterialTypography, {
      variant: "body1"
    }, t("units.addQueueDialogText"))),
    actions: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
      onClick: handleAddQueueCancel,
      variant: "text",
      translate: "units.addQueueDialogCancel"
    }), /* @__PURE__ */ React.createElement(Button, {
      onClick: handleAddQueueAccept,
      variant: "text",
      translate: "units.addQueueDialogAccept"
    }))
  }));
}
export default /* @__PURE__ */ React.memo(MergeUnitsList);
